// Centro completo — grid agrupado por ZONA, orden espacial estable (no reordena por estado).
import PersonaCard from "@/components/centroV3/PersonaCard";

export default function CentroGrid({ grupos, total, onSelect, onAbrirFicha, selectedId }) {
  const dense = total >= 30;
  // Densidad por tamaño del centro y por ancho real (tablet 768/1024 incluidas): de 6 camas a 50+.
  const cols = total >= 50 ? "grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6"
    : total >= 30 ? "grid-cols-2 md:grid-cols-4 lg:grid-cols-5"
    : total >= 10 ? "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4"
    : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3";
  return (
    <section data-testid="centro-grid" className="space-y-5">
      <h2 className="text-sm font-extrabold uppercase tracking-wider text-[#012472]">Centro completo</h2>
      {grupos.map((g, i) => (
        <div key={i} data-testid={`centro-zona-${i}`}>
          <div className="mb-2 flex items-center gap-2">
            <p className="text-xs font-bold uppercase tracking-wide text-slate-500">{g.nombre}</p>
            <span className="text-[11px] tabular-nums text-slate-400">· {g.personas.length}</span>
          </div>
          {g.salaInfo && g.salaInfo.length > 0 && (
            <div data-testid={`centro-sala-info-${i}`} className="mb-2 rounded-lg bg-slate-100 px-3 py-1.5 text-xs text-slate-600">
              {g.salaInfo.map((s, j) => <span key={j}>{s.texto === "Movimiento detectado" ? "Movimiento detectado en habitación" : "Presencia detectada en habitación"} · <span className="tabular-nums text-slate-400">{s.hace}</span>{j < g.salaInfo.length - 1 ? " · " : ""}</span>)}
            </div>
          )}
          <div className={`grid gap-3 ${cols}`}>
            {g.personas.map((p) => <PersonaCard key={p.id} p={p} dense={dense} onSelect={onSelect} onAbrirFicha={onAbrirFicha} selected={p.id === selectedId} />)}
          </div>
        </div>
      ))}
    </section>
  );
}
